import RecordView from "@/components/record/RecordView";
import { CalendarIcon } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { UseQueryResult } from "@tanstack/react-query";
import { ReadProjectSettlements } from "@/schemas/projectSettlements";

interface BasicDataSectionComponentProps {
  query: UseQueryResult<ReadProjectSettlements>;
}

const BasicDataSectionComponent = ({
  query,
}: BasicDataSectionComponentProps) => {
  const { t } = useTranslation();

  return (
    <RecordView
      isOpen
      query={query}
      translationKey={"projectSettlements"}
      header={() => t("projectSettlements.sections.basicData.header")}
    >
      <RecordView.Field
        name="period"
        icon={<CalendarIcon className="w-4 h-4" />}
      />
      <RecordView.Field
        name="period_status"
        renderer={(value) => t(`periodStatuses.${value}`)}
      />
    </RecordView>
  );
};

export const BasicDataSection = memo(
  BasicDataSectionComponent,
  (prevProps, nextProps) => {
    return (
      prevProps.query.data?.id === nextProps.query.data?.id &&
      prevProps.query.data?.period_status ===
        nextProps.query.data?.period_status
    );
  },
);
